module.exports = __webpack_public_path__ + "static/media/btbms-2025-alt2-fr.810bf9a8.jpg";